import React from 'react';
import { useTranslation } from 'react-i18next';
import { Checkbox } from '@gaiads/telia-react-component-library';
import { SalesChannel } from '@cdaas/api-clients/dist/product-service-openapi';

interface ProductInformationProps {
  setting: string;
  value: boolean;
  salesChannel: SalesChannel;
  setSalesChannel: (salesChannel: SalesChannel) => void;
}

export default function ProductInformation(props: ProductInformationProps) {
  const { value, setting, salesChannel, setSalesChannel } = props;

  const { t } = useTranslation('saleschannelform');

  const handleSettingChange = (setting: string, value: boolean) => {
    if (salesChannel.settings) {
      const updatedSalesChannel: SalesChannel = {
        ...salesChannel,
        settings: {
          ...salesChannel.settings,
          [setting]: value,
        },
      };
      setSalesChannel(updatedSalesChannel);
    }
  };
  return (
    <Checkbox
      key={`setting-checkbox-${setting}`}
      checked={value}
      label={t(`settings.${setting}`)}
      onChange={(event, value) => handleSettingChange(setting, value)}
    />
  );
}
